import PropTypes from 'prop-types';
import DropdownSelect from 'components/commons/DropdownSelect';
import { Stack, Typography } from '@mui/material';
import RangeCreatableSelectWithUnit from 'components/commons/RangeAutocompleteWithUnit';

const RpRangeWithUnitFilter = function({ isDropdown = true, ...props }) {
    const content = (
        <>
            <Stack spacing={2} mb={0.5}>
                <Typography variant="text1" gutterBottom>{props.label}</Typography>
            </Stack>
            <Stack spacing={2} mb={1}>
                <Typography variant="subtitle1" gutterBottom>{props.subLabel}</Typography>
            </Stack>
            <Stack mb={1}>
                <RangeCreatableSelectWithUnit
                    minOptions={props.minOptions}
                    maxOptions={props.maxOptions}
                    minValue={props.minValue}
                    maxValue={props.maxValue}
                    unitValue={props.unitValue}
                    onChange={props.onChange}
                    formatter={props.formatter}
                    validateInput={props.validateInput}
                    onError={props.onError}
                    sx={!isDropdown ? { width: '100%' } : null}
                />
            </Stack>
        </>
    );
    return isDropdown !== false ? (
        <DropdownSelect
            label={props.label}
            value={props.value}
            width={props.width || 140}
            active={props.active}
            error={props.error}
        >
            {content}
        </DropdownSelect>
    ) : content;
};

RpRangeWithUnitFilter.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    width: PropTypes.number,
    active: PropTypes.bool,
    error: PropTypes.bool,
    subLabel: PropTypes.string,
    minOptions: PropTypes.array.isRequired,
    maxOptions: PropTypes.array.isRequired,
    minValue: PropTypes.object.isRequired,
    maxValue: PropTypes.object.isRequired,
    unitValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    formatter: PropTypes.func,
    validateInput: PropTypes.func,
    onError: PropTypes.func,
};

export default RpRangeWithUnitFilter;